import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataEntityMassApiResponse, DataEntityMassSaveRequest, MassConfiguration, MassLimits } from 'src/app/Interface/DataEntity/DataEntityMassForm_Interface';
import { environment } from 'src/environments/environment';

export const DATA_ENTITY_MASS_FORM_ENDPOINT = 'api/Weight/MassCertificate';

@Injectable({ providedIn: 'root' })
export class DataEntityMassFormService {
  constructor(private http: HttpClient) { }

  get(id: number): Observable<DataEntityMassApiResponse> {
    return this.http.get<DataEntityMassApiResponse>(
      `${environment.LabUrl}${DATA_ENTITY_MASS_FORM_ENDPOINT}?CalibrationDetailId=${id}`);
  }

  configuration(): Observable<MassConfiguration> { return this.http.get<MassConfiguration>(environment.LabUrl + 'api/Weight/MassConfiguration'); }
  limits(nominalValue: number, unit: string, weightClass: string): Observable<MassLimits> {
    return this.http.get<MassLimits>(environment.LabUrl + 'api/Weight/MassLimits', { params: { nominalValue: String(nominalValue), unit, weightClass } });
  }
  save(model: DataEntityMassSaveRequest): Observable<DataEntityMassApiResponse> {
    return this.http.post<DataEntityMassApiResponse>(environment.LabUrl + DATA_ENTITY_MASS_FORM_ENDPOINT, model);
  }

  getCertificate(id: number): Observable<DataEntityMassApiResponse> { return this.get(id); }

  downloadFile(path: string): Observable<Blob> {
    const relative = path.replace(/^\/+/, '');
    const resource = /^Certificates\/mass\//i.test(relative) ? relative : 'Certificates/mass/' + relative;
    const url = /^https?:\/\//i.test(path) ? path : `${environment.LabUrl.replace(/\/+$/, '')}/${resource}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
